// File: src/components/FeedbackToast/FeedbackToast.tsx
// Purpose: Simple toast notification for feedback submission

import React, { useEffect } from "react";
import styles from "./FeedbackToast.module.css";

interface FeedbackToastProps {
    message: string;
    type: "success" | "error";
    onClose: () => void;
    duration?: number;
}

export const FeedbackToast: React.FC<FeedbackToastProps> = ({ message, type, onClose, duration = 3000 }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    return (
        <div className={`${styles.toast} ${styles[type]}`}>
            <span className={styles.icon}>{type === "success" ? "✓" : "✕"}</span>
            <span className={styles.message}>{message}</span>
        </div>
    );
};
